var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var UnavailableShiftTranslationKeys = {
    SHOW_ALL_UNAVAILABLE: 'shift_management_views_filters_Unavailable_showAllUnavailable',
    EXCEEDS_HOURS_CAP: 'shift_management_views_filters_Unavailable_exceedHoursCap',
    OVERLAPS_WITH_SCHEDULE: 'shift_management_views_filters_Unavailable_overlapsWithSchedule'
};
export var UnavailableShiftFilterInitialState = Object.values(UnavailableShiftTranslationKeys).reduce(function (total, current) {
    var _a;
    return (__assign(__assign({}, total), (_a = {}, _a[current] = false, _a)));
}, {});
